(function() {
    'use strict';
    angular
        .module('MW.ContactManager.SourceFilter', [])
        .filter('sourceFilter', function() {
            return function(sources, predictionFilter) {
                var matchingSources = [];

                // if we do not have data in the correct format, don\'t attempt to filter
                if(!Array.isArray(sources)) {
                    return sources;
                }

                // if we aren't filtering, return all sources
                if(Object.keys(predictionFilter).length <= 0) {
                    return sources;
                }

                // check each source to find ones that match the filter
                sources.forEach(function(source) {
                    var matchesFilter = false;

                    // check each Filter Key/Category until we find one that matches this source
                    matchesFilter = Object.keys(predictionFilter).some(function (predictionKey) {
                        if (predictionFilter[predictionKey] !== null) {
                            var sourceValueArray = [];

                            switch (predictionKey.toLowerCase()) {
                                case 'name':
                                    sourceValueArray = [source.name];
                                    break;
                                case 'address':
                                    sourceValueArray = source.contactInfo.addresses.map(function (addressObject) {
                                        var addressFields = [addressObject.street, addressObject.street2, addressObject.city, addressObject.stateOrProvince, addressObject.zip, addressObject.countryName],
                                            addressArray = [];

                                        addressFields.forEach(function(addressValue) {
                                            if(addressValue) {
                                                addressArray.push(addressValue);
                                            }
                                        });

                                        return addressArray.join(' ');
                                    });
                                    break;
                                case 'emailaddress':
                                    sourceValueArray = source.contactInfo.email.map(function (emailObject) {
                                        return emailObject.address;
                                    });
                                    break;
                                case 'phonenumber':
                                    sourceValueArray = source.contactInfo.phone.map(function (phoneObject) {
                                        return phoneObject.number;
                                    });
                                    break;
                                case 'socialprofile':
                                    sourceValueArray = source.socialProfiles.map(function (socialProfileObject) {
                                        return socialProfileObject.userName;
                                    });
                                    break;
                                case 'beat':
                                    if(source.beats){
                                        sourceValueArray = source.beats.map(function (beatObject) {
                                            return beatObject.name;
                                        });
                                    } else {
                                        return false;
                                    }
                                    break;
                                default:
                                    // can\'t match what we don\'t know
                                    return false;
                            }

                            return sourceValueArray.some(function (sourceValue) {
                                return (sourceValue && (sourceValue.toLowerCase().indexOf(predictionFilter[predictionKey].toLowerCase()) >= 0));
                            });
                        }
                    });

                    if(matchesFilter) {
                        matchingSources.push(source);
                    }
                });

                return matchingSources;
            };
        });
}());